export default {
  computed: {
    showExpiredTrialBanner() {
      const pv = this.$store.getters['productVars/get']['showExpiredTrialBanner'];
      return pv && pv.value;
    },
    trialPurchaseReceipt() {
      return this.$store.getters['purchaseReceipts/all'].find(pr => pr.trialMode);
    },
    trialPurchaseReceiptExpiration() {
      return new Date(this.trialPurchaseReceipt.expiresAt);
    },
    trialPurchaseReceiptExpired() {
      return new Date() > this.trialPurchaseReceiptExpiration;
    },
    // this applies to free (non-paid) trials only
    freeTrialEnabled() {
      return this.$store.getters['app/freeTrialDuration'] > 0;
    },
    // this applies to the paid trial only
    trialEnabled() {
      return this.trialDays > 0;
    },
    trialDays() {
      return this.$store.getters['app/trialDuration'];
    },
    trialDurationText() {
      if (this.trialDays === 1) {
        return '1 day';
      } else {
        return `${this.trialDays} days`;
      }
    },
  },
};